import { LayoutComponent } from '../layout/layout.component';
import { Error404Component} from './pages/error404/error404.component';

export const routes = [

  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'product', loadChildren: () => import('./product-management/product-management.module').then(m => m.ProductManagementModule) },
      { path: 'group', loadChildren: () => import('./group-management/group-management.module').then(m => m.GroupManagementModule) },
    ]
  },

  // Not lazy-loaded routes
  { path: '404', component: Error404Component },

  // Not found
  { path: '**', redirectTo: '404' }

];
